import { platformApi } from "@/api/http";

export interface AnalyticsSummary {
  from: string;
  to: string;
  totalAppointments: number;
  totalRevenue: number;
  avgTicket: number;
  revenueTrend?: { percentage: number; positive: boolean };
  appointmentsTrend?: { percentage: number; positive: boolean };
}

export const analyticsApi = {
  getSummary: async (businessId: string, from: string, to: string): Promise<AnalyticsSummary> => {
    const { data } = await platformApi.get(
      `/api/v1/businesses/${businessId}/analytics/summary`,
      { params: { from, to } },
    );
    return data as AnalyticsSummary;
  },
};
